import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { BautagebuchDialogShellComponent } from '../dialog-shell/bautagebuch-dialog-shell.component';
import {
  BautagebuchDialogData,
  BautagebuchWorkspaceKey
} from '../models/bautagebuch-dialog-data.model';

interface LegacySimplifiedFormConfig {
  messageType: string;
  sectionPath: string;
  sectionTitle: string;
  caseId?: string;
  mode?: 'new' | 'edit' | 'preview';
  draftId?: string;
  destinationId?: string;
  serviceType?: string;
  serviceName?: string;
  organisationId?: number;
  organisationName?: string;
  existingFieldValues?: { [key: string]: any };
  inReplyToMessageId?: string;
  inReplyToMessageType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BautagebuchDialogLauncherService {
  constructor(private dialog: MatDialog) {}

  openWorkspace(data: BautagebuchDialogData): MatDialogRef<BautagebuchDialogShellComponent> {
    this.lockBackgroundScroll();

    const dialogRef = this.dialog.open(BautagebuchDialogShellComponent, {
      width: '88vw',
      maxWidth: '1400px',
      maxHeight: 'calc(100vh - 70px)',
      position: { top: '26px' },
      disableClose: true,
      panelClass: 'simplified-form-dialog-panel',
      data
    });

    dialogRef.afterClosed().subscribe(() => this.unlockBackgroundScroll());

    return dialogRef;
  }

  openFromSimplifiedFormConfig(
    config: LegacySimplifiedFormConfig
  ): MatDialogRef<BautagebuchDialogShellComponent> | null {
    const workspaceKey = this.resolveWorkspaceKey(config.messageType);
    if (!workspaceKey) {
      return null;
    }

    return this.openWorkspace({
      workspaceKey,
      viewKey: workspaceKey === 'tagesbericht-nu' ? 'nu' : 'gu',
      ...config
    });
  }

  isWorkspaceMessageType(messageType: string): boolean {
    return this.resolveWorkspaceKey(messageType) !== null;
  }

  private resolveWorkspaceKey(messageType: string): BautagebuchWorkspaceKey | null {
    if (messageType === 'tagesbericht.nachunternehmer.0001') {
      return 'tagesbericht-nu';
    }

    if (messageType === 'bautagebuch.unified.0001') {
      return 'bautagebuch-gu';
    }

    return null;
  }

  private lockBackgroundScroll(): void {
    if (typeof window === 'undefined') {
      return;
    }

    window.scrollTo({ top: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document
      .querySelectorAll(
        '.content, .contentNoSideMenu, .mat-drawer-content, .dataspace-workspace-page, .dataspace-layout__detail'
      )
      .forEach((element) => {
        if (element instanceof HTMLElement) {
          element.scrollTop = 0;
          element.style.overflowY = 'hidden';
        }
      });
  }

  private unlockBackgroundScroll(): void {
    if (typeof window === 'undefined') {
      return;
    }

    document
      .querySelectorAll(
        '.content, .contentNoSideMenu, .mat-drawer-content, .dataspace-workspace-page, .dataspace-layout__detail'
      )
      .forEach((element) => {
        if (element instanceof HTMLElement) {
          element.style.overflowY = '';
        }
      });
  }
}
